const stateKeySuffix = "9734kjdfu98dfjf-6jh234hsd8";

const toStateKey = (key) => "state_" + key + "_" + stateKeySuffix;

export function loadTaskPosition(viewportId) {
  let result = sessionStorage.getItem(toStateKey(viewportId));
  return JSON.parse(result);
}

export function saveTaskPosition(viewportId, position) {
  let value = JSON.stringify(position);
  sessionStorage.setItem(toStateKey(viewportId), value);
}

export function clearTaskPosition(viewportId) {
  sessionStorage.removeItem(toStateKey(viewportId));
}